import React, {
  useEffect,
  useState
} from 'react';

import { useNavigate } from 'react-router-dom';

import './Certificate.css';

import TopBar from '../../../topBar/TopBar';
import GetProCard from '../../../rightSidebar/components/GetProCard';
import FooterElements from '../../../rightSidebar/components/FooterElements';
import SocialElements from '../../../rightSidebar/components/SocialElements';
import CerificateButton from '../../../rightSidebar/components/CerificateButton';

import '../reglaredimensiune.css';


export default function Certificate() {

  const navigate = useNavigate();

  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  /* =========================
     INCARCARE CERTIFICATE
  ========================= */

useEffect(() => {

  fetch(
    `${process.env.REACT_APP_API_URL}/certificates`,
    {
      credentials: 'include'
    }
  )
    .then(async (res) => {

      const data = await res.json();

      if (!res.ok) {
        throw new Error(
          data?.error ||
          'Certificatele nu au putut fi incarcate'
        );
      }

      return data;

    })
    .then((data) => {

      console.log(
        'Certificate primite:',
        data
      );

      setCertificates(
        Array.isArray(data.certificates)
          ? data.certificates
          : []
      );

    })
    .catch((error) => {

      console.error(
        'Eroare la incarcarea certificatelor:',
        error
      );

      setError(
        'Certificatele nu au putut fi incarcate.'
      );

    })
    .finally(() => {

      setLoading(false);

    });

}, []);


  /* =========================
     FORMATARE DATA
  ========================= */

  const formatDate = (date) => {

    if (!date) {
      return '-';
    }

    return new Date(
      date
    ).toLocaleDateString(
      'ro-RO'
    );

  };


  /* =========================
     VEZI CERTIFICAT
  ========================= */

  const handleViewCertificate = (certificate) => {

    navigate(
      `/diploma?courseId=${certificate.course_id}`
    );

  };


  /* =========================
     VERIFICA CERTIFICAT
  ========================= */

  const handleVerifyCertificate = (certificate) => {

    navigate(
      `/verify/${certificate.certificate_code}`
    );

  };


  /* =========================
     CONTINUA CURSUL
  ========================= */

  const handleContinueLearning = () => {

    navigate('/showlessons');

  };


  return (

    <div className="componentsmenu-container-main">


      <div className="componentsmenu-left-blank" />


      <div className="componentsmenu-container">


        <TopBar />


        <div className="certificate-card">


          {/* =========================
              TITLU
          ========================= */}

          <div className="certificate-title">
            Certificatele mele
          </div>


          {/* =========================
              DESCRIERE
          ========================= */}

          <div className="certificate-description">

            Aici gasesti certificatele obtinute pentru
            cursurile finalizate pe ContaLearn.

          </div>


          {/* =========================
              LOADING
          ========================= */}

          {loading && (

            <div className="certificate-loading">

              <div className="certificate-loader" />

              <span>
                Se incarca certificatele...
              </span>

            </div>

          )}


          {/* =========================
              EROARE
          ========================= */}

          {!loading && error && (

            <div className="certificate-error">

              {error}

            </div>

          )}


          {/* =========================
              FARA CERTIFICATE
          ========================= */}

          {!loading &&
            !error &&
            certificates.length === 0 && (

            <>

              <div className="certificate-empty">

                <div className="certificate-empty-icon">
                  🎓
                </div>


                <div className="certificate-empty-content">

                  <strong>
                    Nu ai obtinut inca niciun certificat.
                  </strong>

                  <span>
                    Finalizeaza un curs pentru a debloca
                    primul tau certificat digital.
                  </span>

                </div>

              </div>


              <button
                type="button"
                className="certificate-continue-btn"
                onClick={handleContinueLearning}
              >

                <span>
                  Continua sa inveti
                </span>

              </button>

            </>

          )}


          {/* =========================
              CERTIFICATE OBTINUTE
          ========================= */}

          {!loading &&
            !error &&
            certificates.length > 0 && (

            <div className="certificate-list">

              {certificates.map((certificate) => (

                <div
                  className="certificate-item"
                  key={certificate.certificate_code}
                >


                  <div className="certificate-item-top">


                    <div className="certificate-item-main">

                      <div className="certificate-item-label">
                        Certificat de competente
                      </div>


                      <div className="certificate-item-title">
                        {certificate.course_name}
                      </div>


                      <div className="certificate-item-date">

                        Finalizat la{' '}

                        <strong>
                          {formatDate(
                            certificate.completed_at
                          )}
                        </strong>

                      </div>


                      <div className="certificate-item-code">

                        {certificate.certificate_code}

                      </div>

                    </div>


                


                  </div>


                  <div className="certificate-item-actions">


                    <button
                      type="button"
                      className="certificate-action-primary"
                      onClick={() =>
                        handleViewCertificate(
                          certificate
                        )
                      }
                    >

                      Vezi certificatul

                    </button>


                 


                  </div>


                </div>

              ))}

            </div>

          )}


        </div>


      </div>


  


    </div>

  );

}